import React from 'react';
import { makeStyles } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Skeleton from '@material-ui/lab/Skeleton';
import { colors } from '@skyslope/mache';

interface IProps {
  columns?: any[];
  numberOfColumns?: number;
}

const useStyles = makeStyles(() => ({
  tableRow: {
    backgroundColor: '#FFFFFF',
    color: colors.grey[800],
    borderColor: colors.grey[400],
    padding: '0 24px',
    height: 64,
  },
  tableCell: {
    color: colors.grey[800],
    borderColor: colors.grey[400],
    padding: '0 24px',
  },
}));

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const SkeletonRow = (props: IProps) => {
  const { columns, numberOfColumns } = props;
  const classes = useStyles(props);

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const cellToRender = (i: number) => (
    <TableCell key={i} className={classes.tableCell}>
      <Skeleton animation="wave" />
    </TableCell>
  );

  return (
    <TableRow className={classes.tableRow}>
      {columns ? columns.map((_, i) => cellToRender(i)) : [...Array(numberOfColumns || 3)].map((i) => cellToRender(i))}
    </TableRow>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default SkeletonRow;
